import { SortDirectionEnum } from 'sprava-aktov-eu-frontend-ts-axios';
import { PravoEuFilter } from '../../../model/PravoEuFilter';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { fetchPravoEuList } from '../../../client/fetchPravoEuList';
import PravoEuListPage from '../../../model/PravoEuListPage';
import { defaultSort, sortValues } from '../../../constants/PravoEuSortConstants';

const getSort = (sortValue): string => {
  if (!sortValues.includes(sortValue)) {
    return defaultSort;
  }
  return sortValue;
};

interface ReturnType {
  pravoEuPage?: PravoEuListPage | null;
  status: ClientStatus;
}

export default (page: number, perPageValue: number, sort: string[], filter: PravoEuFilter): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(() => fetchPravoEuList(
    filter,
    page,
    perPageValue,
    getSort(sort[0]),
    sort[1] === 'asc' ? SortDirectionEnum.Asc : SortDirectionEnum.Desc,
  ), [filter, page, perPageValue, sort[0], sort[1]]);

  return {
    pravoEuPage: data,
    status,
  };
};
